module.exports = __webpack_public_path__ + "ecb22588689009c2e4e100a15fa72d65.jpg";